/** @format */

import type { BaseResponse } from '@/utils';
import { request } from '@/utils';

// 查询部门数据列表
export function getDepartment() {
	return request<BaseResponse<any>>(
		{
			url: '/system/dept/treeselect',
			method: 'get',
			params: {},
		},
		{
			isGetDataDirectly: true,
		},
	);
}

// 查询用户数据列表
export function getUserData() {
	return request<BaseResponse<any>>(
		{
			url: '/system/user/list',
			method: 'get',
			params: {
				pageNum: 1,
				pageSize: 100000,
			},
		},
		{
			isGetDataDirectly: false,
		},
	);
}
